import { Component, ElementRef, Injector } from '@angular/core';
import { CheckoutConfirmationComponentDef } from '@df/checkout/checkout-confirmation.component.def';
import { App } from '@df/core/app';
import { Logger } from '@df/core/service/logger';
import { ScrollToErrorService } from '@df/ui/form/scroll-to-error.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { CheckoutFormComponent } from './../form/checkout-form.component';
@Component({
    selector: 'checkout-confirmation',
    templateUrl: './checkout-confirmation.html',
    styleUrls: ['checkout-confirmation.scss'],
    standalone: true,
    imports: [TranslationModule]
})
export class CheckoutConfirmationComponent extends CheckoutConfirmationComponentDef {
    constructor(
        checkoutFormComponent: CheckoutFormComponent,
        protected override ngEl: ElementRef,
        override readonly app: App,
        protected override logger: Logger,
        protected override scrollToErrorService: ScrollToErrorService,
        injector: Injector
    ) {
        super(checkoutFormComponent, ngEl, app, logger, scrollToErrorService);
    }
}
